import {VueGoodTable} from 'vue-good-table';
import ApplicationResponseService from '../../../services/ApplicationResponses.js';
import StatusService from '../../../services/Status.js';
import moment from 'moment';
import Paginate from 'vuejs-paginate';

if ($('#versions').length) {
    var app = new Vue({
        el: '#versions',
        data: {
            network: network,
            networkId: networkId,
            networkSlug: networkSlug,
            networkGroupSlug: networkGroupSlug,
            data: {},
            isLoading: true,
            applicationResponses: [],
            statuses: [],
            columns: [
                {
                    label: 'Version no.',
                    field: 'version_no',
                },
                {
                    label: 'Created on',
                    field: 'date',
                },
                {
                    label: 'Changelog',
                    field: 'changelog',
                    sortable: false,
                },
                {
                    label: 'Actions',
                    field: 'actions',
                    sortable: false,
                },
                {
                    label: 'Rollback',
                    field: 'rollback',
                    sortable: false,
                },
            ],
            rows: [],
            totalRecords: 0,
            lastPage: 0,
            serverParams: {
                sort: {
                    field: '',
                    type: '',
                },
                page: 1,
                total: 0
            }
        },
        methods: {
            get() {
                this.isLoading = true;
                axios.get('/api/v1/network/' + this.networkId + '/versions', {
                    params: {
                        sortField: this.serverParams.sort.field,
                        sortType: this.serverParams.sort.type,
                        page: this.serverParams.page
                    }
                }).then((response) => {
                    this.data = response.data.network_versions;
                    var rows = [];
                    this.serverParams.perPage = this.data.per_page;
                    this.serverParams.page = this.data.current_page;
                    this.totalRecords = this.data.total;
                    this.lastPage = this.data.last_page;
                    this.data.data.forEach(function (object) {
                        var row = {
                            version_no: object.version,
                            date: moment(object.created_at).format('LLL'),
                            changelog: object.changelog,
                            rollbacked: object.rollbacked,
                            id: object.id,
                        }
                        rows.push(row);
                    });
                    this.rows = rows;
                    this.isLoading = false;
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            paginate(object) {
                this.get();
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.get();
            },
            onSortChange(params) {
                this.updateParams({page: 1});
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.get();
            },
            errorHandler(error) {
                if (typeof error.response.data === 'string') {
                    this.$toasted.error(error.response.data);
                } else {
                    this.$toasted.error(error.response.data.message);
                }
                this.isLoading = false;
            },
            rollback(id) {
                this.isLoading = true;
                axios.get('/organisation/' + this.networkGroupSlug + '/' + this.networkSlug + '/administration/rollback/' + id, {
                    params: {
                        ajax: 1
                    }
                }).then((response) => {
                    this.get();
                    this.$toasted.success('Network rollbacked');
                    this.isLoading = false;
                }).catch((error) => {
                    this.errorHandler(error);
                });
            }
        },
        components: {
            'paginate': Paginate,
            'vue-good-table': VueGoodTable
        },
        mounted() {
            this.get();

            ApplicationResponseService.getApplicationResponses().then(data => {
                this.applicationResponses = data;
            });

            StatusService.getStatuses().then(data => {
                this.statuses = data;
            });
        }
    });
}